import { Input } from '../../../Components'
import { cap } from '../../../State'
import { translations } from '../../../translations'
/* import { STATUS_OPTIONS } from '../constants' */

const language = cap.language.state || 'IT'
const t = translations[language]

/**
 * Sezione filtri: header con badge attivi e pulsante reset, riga con dropdown Isola, Unità op., Cliente.
 * @param {Object} props
 * @param {Object} props.filters - { isola, unitOp, codCliente, status }
 * @param {Function} props.setFilters - Setter stato filtri
 * @param {Array} props.isoleList - Opzioni dropdown isole
 * @param {Array} props.unitOpList - Opzioni dropdown unità operative
 * @param {Array} [props.codClientiList] - Opzioni dropdown clienti (opzionale)
 * @returns {JSX.Element}
 */
export function StatisticsFiltersSection({
  filters,
  setFilters,
  isoleList,
  unitOpList,
  codClientiList = []
}) {
  const hasActiveFilters = filters.isola || filters.unitOp || filters.codCliente || filters.status
  const activeFilterCount = [
    filters.isola,
    filters.unitOp,
    filters.codCliente,
    filters.status
  ].filter(Boolean).length

  const handleResetFilters = () => {
    setFilters({ isola: '', unitOp: '', codCliente: '', status: '' })
  }

  return (
    <div className="ncard stats-filters-section">
      <div className="ncard__head">
        <div className="ncard__ico">
          <i className="pi pi-filter" style={{ fontSize: 16 }} />
        </div>
        <div>
          <h3 className="ncard__title">{t.filters}</h3>
          <div className="ncard__sub">{t.filtraPerIsolaUnitaCliente}</div>
        </div>
        <div className="ncard__head-actions">
          {activeFilterCount > 0 && (
            <span className="nbadge nbadge--info">
              {activeFilterCount} {activeFilterCount === 1 ? t.activeFilterOne : t.activeFilterMany}
            </span>
          )}
          {hasActiveFilters && (
            <button
              type="button"
              className="nbtn nbtn--ghost nbtn--sm"
              onClick={handleResetFilters}
              aria-label={t.removeAllFilters}
            >
              <i className="pi pi-times" style={{ fontSize: 11 }} />
              {t.reset}
            </button>
          )}
        </div>
      </div>
      <div className="ncard__body">
        <div className="stats-filters-row">
          <div className="nfield" style={{ minWidth: 190, flex: '1 1 190px' }}>
            <label>{t.island}</label>
            <Input
              dropdown
              id="isola"
              placeholder={t.allIslands}
              value={filters.isola}
              options={[{ id: '', name: t.allIslands }, ...isoleList]}
              optionLabel="name"
              optionValue="id"
              onChange={(e) => setFilters((prev) => ({ ...prev, isola: e.isola }))}
              showClear={!!filters.isola}
              style={{ width: '100%' }}
            />
          </div>
          <div className="nfield" style={{ minWidth: 220, flex: '1 1 220px' }}>
            <label>{t.unitaOperativa}</label>
            <Input
              dropdown
              id="unitOp"
              placeholder={t.tutteLeUnitaOp}
              value={filters.unitOp}
              options={[{ id: '', name: t.tutteLeUnitaOp }, ...unitOpList]}
              optionLabel="name"
              optionValue="id"
              onChange={(e) => setFilters((prev) => ({ ...prev, unitOp: e.unitOp }))}
              showClear={!!filters.unitOp}
              style={{ width: '100%' }}
            />
          </div>
          {codClientiList?.length > 0 && (
            <div className="nfield" style={{ minWidth: 220, flex: '1 1 220px' }}>
              <label>{t.client}</label>
              <Input
                dropdown
                id="codCliente"
                placeholder={t.tuttiIClienti}
                value={filters.codCliente}
                options={[{ id: '', name: t.tuttiIClienti }, ...codClientiList]}
                optionLabel="name"
                optionValue="id"
                onChange={(e) => setFilters((prev) => ({ ...prev, codCliente: e.codCliente }))}
                showClear={!!filters.codCliente}
                filter
                filterPlaceholder={t.cercaCliente}
                style={{ width: '100%' }}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
